import React, { useState, useEffect } from "react";
import "./Home.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";


const images = [
  process.env.PUBLIC_URL + "/images/hero1.jpg",
  process.env.PUBLIC_URL + "/images/hero2.jpeg",
  process.env.PUBLIC_URL + "/images/hero4.jpg",
];

const headings = ["Riksons Inspection Services"];

const statsData = [
  { label: "Team Members", value: 50 },
  { label: "Years Experience (avg)", value: 7 },
  { label: "Projects Completed", value: 120 },
  { label: "Vendors Developed", value: 35 },
];

const Home = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [currentHeading, setCurrentHeading] = useState(0);
  const [counts, setCounts] = useState(statsData.map(() => 0));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
      setCurrentHeading((prev) => (prev + 1) % headings.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    setCurrentHeading((prev) => (prev === 0 ? headings.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
    setCurrentHeading((prev) => (prev + 1) % headings.length);
  };

  // Counter Animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            statsData.forEach((stat, index) => {
              let start = 0;
              const end = stat.value;
              const duration = 2000;
              const stepTime = Math.abs(Math.floor(duration / end));
              const counter = setInterval(() => {
                start += 1;
                setCounts((prev) => {
                  const updated = [...prev];
                  updated[index] = start;
                  return updated;
                });
                if (start === end) clearInterval(counter);
              }, stepTime);
            });
          }
        });
      },
      { threshold: 0.3 }
    );

    const statsSection = document.querySelector(".stats-section");
    if (statsSection) observer.observe(statsSection);

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* ===== Hero Section ===== */}
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${images[currentImage]})` }}
      >
        <div className="overlay"></div>

        <div className="hero-content-left">
          <h4>QUALITY IS OUR TOP PRIORITY</h4>
          <h1>{headings[0]}</h1>
          <p>
            Inspection and NDT services specializing in machining, fabrication,
            casting and vendor development — delivering reliable, certified
            inspection with experienced ASNT Level II staff.
          </p>
          <div className="hero-buttons">
            <button className="hero-btn">Contact Us</button>
            <button className="hero-btn hero-btn-secondary">Our Services</button>
          </div>
        </div>

        {/* Arrows */}
        <FaArrowLeft className="arrow left" onClick={prevSlide} />
        <FaArrowRight className="arrow right" onClick={nextSlide} />
      </section>

      {/* ===== Overlapping Stats Section ===== */}
      <section className="stats-section">
        <div className="stats-left">
          <h4>COMPANY SNAPSHOT</h4>
          <h2>Riksons Inspection Services</h2>
          <p>
            Started in September 2021 at Kirloskarwadi, with an experienced team
            that brings 6–7 years of prior industry experience. We provide
            inspection, NDT and vendor development services across multiple
            industrial verticals.
          </p>
          <button className="stats-btn">Get In Touch →</button>
        </div>

        <div className="stats-right">
          {statsData.map((stat, index) => (
            <div className="stat-box" key={index}>
              <h3>{counts[index].toLocaleString()}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== About Us / Company Profile ===== */}
      <section className="about-section">
        <div className="about-left">
          <h5>COMPANY PROFILE</h5>
          <h2>Riksons Inspection Services</h2>
          <p>
            “Riksons Inspection Services” is a developing leader in inspection
            and NDT services. We assure great quality and excellent services.
            Our knowledgeable team aims to provide excellent quality services to
            our customers. The company was established in September 2021 at
            Kirloskarwadi with prior experience of 6–7 years before formation.
          </p>

          <div className="about-points">
            <div className="point"><span>✔</span> Inspection of Machining components</div>
            <div className="point"><span>✔</span> Inspection of Fabrication components</div>
            <div className="point"><span>✔</span> RT film review</div>
            <div className="point"><span>✔</span> LPT & MPT witness</div>
            <div className="point"><span>✔</span> UT witness</div>
            <div className="point"><span>✔</span> Vendor Development & Follow-up</div>
          </div>
        </div>

        <div className="about-right">
          <img
            src={process.env.PUBLIC_URL + "/images/hero1.jpg"}
            alt="Inspection"
          />
        </div>
      </section>

<section className="marquee-section">
  <Marquee speed={50} gradient={false}>
    Welcome to our website! This text scrolls smoothly using react-fast-marquee.
  </Marquee>
</section>



      {/* ===== Services Section ===== */}
      <section className="services-section">
        <div className="services-header">
          <h5>OUR SERVICES</h5>
          <h2>Inspection & NDT Services</h2>
        </div>

        <div className="services-content">
          <div className="services-left">
            <div className="services-points-column">
              <div className="service-point">Inspection of Machining components</div>
              <div className="service-point">Inspection of Fabrication components</div>
              <div className="service-point">RT film review</div>
              <div className="service-point">LPT & MPT witness</div>
            </div>
          </div>

          <div className="services-middle">
            <img
              src={process.env.PUBLIC_URL + "/images/Service.png"}
              alt="Inspection Services"
            />
          </div>


          <div className="services-right">
            <p>
              We are committed to inspecting products carefully and fulfilling
              customer requirements at competitive cost. Our core strategy is
              'Customer First' — understanding needs and providing comprehensive
              inspection and certification support.
            </p>
            <Link to="/services" className="services-btn">Read More →</Link>
          </div>
        </div>
      </section>
       
      {/* ===== Next Section with Background Image ===== */}
  <section
  className="bg-text-section"
  style={{
    backgroundImage: `url(${process.env.PUBLIC_URL + "/images/hero4.jpg"})`,
  }}
>
  <div className="bg-text-content">
    <h5>OUR STRENGTHS</h5>
    <h2>Professional Team & Latest Techniques</h2>
    <p>
      The name and service strength earned by our organization is due to
      professionally qualified staff and innovative management keeping the
      company aligned to latest technologies.
    </p>
    <button className="bg-text-btn">Read Company Profile →</button>
  </div>
</section>

{/* ===== Products Section ===== */}
<section className="products-section">
  <div className="products-grid">
    {/* First Row */}
    <div className="product-card">
      <h5>VISION & MISSION</h5>
      <h2>Complete Solution Provider</h2>
      <p>
        To become a ‘Complete Solution Provider’ of inspection
        components by providing standard quality at competitive cost with
        excellent service.
      </p>
      
      <button className="product-btn">Download Profile →</button>
    </div>

    <div className="product-card">
      <img src={process.env.PUBLIC_URL + "/images/hero1.jpg"} alt="Product 1" />
    </div>

    <div className="product-card">
      <img src={process.env.PUBLIC_URL + "/images/hero2.jpeg"} alt="Product 2" />
    </div>

    {/* Second Row */}
    <div className="product-card">
      <img src={process.env.PUBLIC_URL + "/images/hero1.jpg"} alt="Product 3" />
    </div>

    <div className="product-card">
      <img src={process.env.PUBLIC_URL + "/images/hero1.jpg"} alt="Product 4" />
    </div>

    <div className="product-card">
      <img src={process.env.PUBLIC_URL + "/images/hero1.jpg"} alt="Product 5" />
    </div>
  </div>
</section>

{/* ===== Our Clients Section ===== */}
<section className="clients-section">
  <h5>OUR CLIENTS</h5>
  <h2>Trusted by Leading Brands</h2>

  <div className="clients-carousel">
    <div className="clients-track">
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/1.png"} alt="Client 1" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/2.png"} alt="Client 2" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/3.png"} alt="Client 3" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/4.png"} alt="Client 4" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/1.png"} alt="Client 5" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/2.png"} alt="Client 6" />
      </div>

      {/* Duplicate logos for smooth infinite scroll */}
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/1.png"} alt="Client 1" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/2.png"} alt="Client 2" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/3.png"} alt="Client 3" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/4.png"} alt="Client 4" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/1.png"} alt="Client 5" />
      </div>
      <div className="client-logo">
        <img src={process.env.PUBLIC_URL + "/images/2.png"} alt="Client 6" />
      </div>
    </div>
  </div>
</section>

{/* ===== OUR GALLERY Section ===== */}
<section className="gallery-section">
  <div className="welcome-header">
    <h5>OUR GALLERY</h5>
    <h2>Inspection & Machined Parts</h2>
  </div>
  
  <div className="gallery-grid">
    <div className="gallery-item">
      <img src={process.env.PUBLIC_URL + "/images/gallery1.png"} alt="Inspection Part 1" />
      <div className="gallery-caption">Shaft Sleeve</div>
    </div>
    <div className="gallery-item">
      <img src={process.env.PUBLIC_URL + "/images/gallery2.png"} alt="Inspection Part 2" />
      <div className="gallery-caption">Muff Coupling</div>
    </div>
    <div className="gallery-item">
      <img src={process.env.PUBLIC_URL + "/images/gallery1.png"} alt="Inspection Part 3" />
      <div className="gallery-caption">Bearing Cover</div>
    </div>
    <div className="gallery-item">
      <img src={process.env.PUBLIC_URL + "/images/gallery2.png"} alt="Inspection Part 4" />
      <div className="gallery-caption">Flange</div>
    </div>
    <div className="gallery-item">
      <img src={process.env.PUBLIC_URL + "/images/gallery1.png"} alt="Inspection Part 5" />
      <div className="gallery-caption">Shaft Sleeve</div>
    </div>
    <div className="gallery-item">
      <img src={process.env.PUBLIC_URL + "/images/gallery2.png"} alt="Inspection Part 6" />
      <div className="gallery-caption">Muff Coupling</div>
    </div>
    
  </div>
</section>
    </>
  );
};

export default Home;
